module.exports = __webpack_public_path__ + "static/media/logo-YPL.5d34e543.png";